// extracted by mini-css-extract-plugin
export var sliderRange = "_oq-2";
export var sliderRoot = "_oq-0";
export var sliderThumb = "_oq-3";
export var sliderTrack = "_oq-1";